import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import { userToken } from './services/user'
import axios from 'axios'

Vue.use( Router )

const router = new Router( {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "layouts" */ './views/layouts/default.vue'),
      children: [ {
        path: '/',
        component: () => import(/* webpackChunkName: "userPages" */ './views/home.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Realtime',
          metaTags: [{
            name: 'description',
            content: 'Laporan realtime.'
          }, {
            property: 'og:description',
            content: 'Laporan realtime.'
          }]
        }
      }, {
        path: '/conversions',
        component: () => import(/* webpackChunkName: "userPages" */ './views/conversions.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Conversions',
          metaTags: [{
            name: 'description',
            content: 'Laporan conversions.'
          }, {
            property: 'og:description',
            content: 'Laporan conversions.'
          }]
        }
      }, {
        path: '/statistics',
        component: () => import(/* webpackChunkName: "userPages" */ './views/statistics.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Statistics',
          metaTags: [{
            name: 'description',
            content: 'Laporan Statistics.'
          }, {
            property: 'og:description',
            content: 'Laporan Statistics.'
          }]
        }
      }, {
        path: '/tracker',
        component: () => import(/* webpackChunkName: "userPages" */ './views/tracker.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Tracker',
          metaTags: [{
            name: 'description',
            content: 'Laporan Tracker.'
          }, {
            property: 'og:description',
            content: 'Laporan Tracker.'
          }]
        }
      }, {
        path: '/tracker2',
        component: () => import(/* webpackChunkName: "userPages" */ './views/tracker2.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Tracker 2',
          metaTags: [{
            name: 'description',
            content: 'Laporan Tracker.'
          }, {
            property: 'og:description',
            content: 'Laporan Tracker.'
          }]
        }
      }, {
        path: '/accounts',
        component: () => import(/* webpackChunkName: "userPages" */ './views/accounts.vue'),
        meta: {
          permissions: {
            auth: true,
            role: 'owner'
          },
          title: 'Suksesbos | Manage Accounts',
          metaTags: [{
            name: 'description',
            content: 'Page Manage Accounts.'
          }, {
            property: 'og:description',
            content: 'Page Manage Accounts.'
          }]
        }
      }, {
        path: '404',
        component: () => import(/* webpackChunkName: "userPages" */ './views/not-found.vue'),
        meta: {
          permissions: {
            auth: true
          },
          title: 'Suksesbos | Page not Found',
          metaTags: [{
            name: 'description',
            content: 'Page not Found.'
          }, {
            property: 'og:description',
            content: 'Page not Found.'
          }]
        }
      } ],
      beforeEnter( to, from, next ) {
        const token = userToken()

        if ( !store.state.error.enable ) {
          const SocketInstanceOptions = {
            path: '/socket/server',
            broadcaster: 'socket.io',
            host: process.env.VUE_APP_MAIN_SOCKET,
            forceNew: true,
            withCredentials: true,
          }

          if ( token ) {
            SocketInstanceOptions.query= { session: token }
          }

          const SocketInstance = io( process.env.VUE_APP_MAIN_SOCKET, SocketInstanceOptions )

          if ( !Vue.prototype.$socket ) {
            Vue.use( new VueSocketIO( {
              debug: true,
              connection: SocketInstance,
              vuex: {
                store,
                actionPrefix: 'SOCKET_',
                mutationPrefix: 'SOCKET_'
              }
            } ) )
          }
          else {
            if ( !store.state.socket.connected ) {
              delete Vue.prototype.$socket
              delete Vue.prototype.$vueSocketIo

              const vueSocketIO = new VueSocketIO( {
                debug: true,
                connection: SocketInstance,
                vuex: {
                  store,
                  actionPrefix: 'SOCKET_',
                  mutationPrefix: 'SOCKET_'
                }
              } )

              Vue.prototype.$socket = vueSocketIO.io
              Vue.prototype.$vueSocketIo = vueSocketIO
            }
          }
        }

        next()
      }
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "layouts" */ './views/layouts/guard.vue'),
      children: [{
        path: '',
        component: () => import(/* webpackChunkName: "pages" */'./views/login.vue'),
        meta: {
          title: 'Suksesbos | Login',
          metaTags: [{
            name: 'description',
            content: 'Masuk ke halaman laporan.'
          }, {
            property: 'og:description',
            content: 'Masuk ke halaman laporan.'
          }]
        }
      }]
    }
  ]
} )

router.beforeEach( ( to, from, next ) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if( nearestWithTitle ) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from( document.querySelectorAll('[data-vue-router-controlled]') )
    .map(el => el.parentNode.removeChild(el));

  if( !nearestWithMeta ) {
    return next();
  }

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  .forEach(tag => {
    if (document.title) {
      document.head.insertBefore(tag, document.title.nextSibling);
    }
    else {
      document.head.appendChild(tag);
    }
  });

  next();
} )

router.beforeEach( ( to, from, next ) => {
  const token = userToken();

  const routeMatchAuth = record => {
    return record.meta.permissions ? record.meta.permissions.auth : false
  }

  if ( token && '/login' === to.path ) {
    if ( store.state.authentication.status.loggedIn ) {
      next(  )
      return
    }

    store.dispatch( 'authentication/validation', { token } ).then( () => {
      next( '/' )
    } )
    return
  }

  if ( to.matched.some( routeMatchAuth ) ) {
    if ( !token ) {
      return next( '/login' );
    }

    store.dispatch( 'authentication/validation', { token } ).then( () => {
      next( );
    } ).catch( exception => {
      if ( !exception.response && exception instanceof Error ) {
        store.commit( 'error', {
          enable: true,
          message: exception.message
        } );

        next( );
      }
      else {
        if ( false === axios.isCancel( exception ) ) {
          const data = exception.response.data;

          if ( data.error ) {
            if ( ( 'session' === data.error.code && 401 == exception.response.status ) ||
              ( 'auth' === data.error.code && 403 == exception.response.status ) ) {
              store.dispatch( 'authentication/logout', data.error.message ).then( () => {
                next( '/login' );
              } );
            }
          }
        }
      }

    } );
    return
  }

  next( );
} );

export default router
